import { render } from "./CardUser.vue?vue&type=template&id=cbc0e1b4&scoped=true&ts=true"
import script from "./CardUser.vue?vue&type=script&lang=ts"
export * from "./CardUser.vue?vue&type=script&lang=ts"

import "./CardUser.vue?vue&type=style&index=0&id=cbc0e1b4&scoped=true&lang=scss"

import exportComponent from "/builds/Chirbou/digithia/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbc0e1b4"]])

export default __exports__